import React, {useEffect, useState} from 'react';
import {invokeDAGviaApiPost} from "../../Api/invokeDag";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import ButtonLoader from "../../utils/components/ButtonLoader";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import Checkbox from "../Components/Checkbox";
import {convertGsutilPathToBrowserGcsUrl} from "../../utils/gcsUtils";
import OutletsDropdown from "../Components/Dropdowns/OutletsDropdown";
import PeriodsDropdown from "../Components/Dropdowns/PeriodsDropdown";
import {addLabelToOptionsIfNotExist, getValueFromOptions} from "../../utils/maybeAddLabelToOptions";
import {makeApiCall} from "../../Api/makeApiCall";

const ExtractCleanseSalesToPuc = () => {
    const DAG_ID_TO_TRIGGER = "extract_cleanse_sales_to_puc"

    const [loading, setLoading] = useState(true);
    const [excludeAlreadyProcessedItems, updateExcludeAlreadyProcessedItems] = useState(true);
    const [sourceCheckpointPathOptions, updateSourceCheckpointPathOptions] = useState([]);
    const [sourceCheckpointPath, updateSourceCheckpointPath] = useState(undefined);
    const [outletSelection, updateOutletDropdown] = useState({value:27, outletName:'PLU Fresh'});
    const [period, updatePeriod] = useState(undefined);
    const [projectionsVersionSelection, updateProjectionsVersionDropdown] = useState(undefined);
    const [projectionsVersionOptions, updateProjectionsVersionOptions] = useState([]);

    useEffect(() => {
        setLoading(true);

        const schemasForCheckpointsQuery = `query {
              schemasForCheckpoints( tableData: ["p_data=cleansed_sales_parquet"] ) {
                checkpointPath
              }
            }`

        Promise.all([
            makeApolloClientCall(schemasForCheckpointsQuery),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/projectionsVersions`),
        ]).then(([schemasForCheckpointsResults, projectionsVersionsResults]) => {
            updateSourceCheckpointPathOptions(schemasForCheckpointsResults.schemasForCheckpoints.map((value) => (
                {label: value.checkpointPath, value: value.checkpointPath}
            )));
            updateProjectionsVersionDropdown(projectionsVersionsResults[0])
            updateProjectionsVersionOptions(addLabelToOptionsIfNotExist(projectionsVersionsResults));
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    const triggerDag = () => {
            return invokeDAGviaApiPost(DAG_ID_TO_TRIGGER, {
                exclude_already_processed_items: excludeAlreadyProcessedItems,
                source_checkpoint_path: sourceCheckpointPath,
                outlet: outletSelection.outletName,
                outlet_id: outletSelection.value,
                market_period: period,
                projections_version: projectionsVersionSelection
            });
    };


    return (<Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Produce"}, {label: "Extract Cleanse Sales To Puc"}]}/>} name={"Extract Cleanse Sales To PUC"} beta={true}>
        <LoadingWrapper loading={loading}>
            <div className={'extract-cleanse-sales-to-puc-action-buttons-container'}>
                <div className={'extract-cleanse-sales-to-puc-column'}>
                    <div className={'extract-cleanse-sales-to-puc-selection-row'}>
                        <div className="extract-cleanse-sales-to-puc-inputs exclude-already-processed-items-selection">
                            <Checkbox
                                id={'exclude_already_processed_items_checkbox'}
                                checked={excludeAlreadyProcessedItems}
                                labelText='Exclude Already Processed Items'
                                onChange={() => updateExcludeAlreadyProcessedItems(!excludeAlreadyProcessedItems)}
                            />
                        </div>
                    </div>
                    <div className={'extract-cleanse-sales-to-puc-selection-row'}>
                        <div className="extract-cleanse-sales-to-puc-inputs source-checkpoint-path-dropdown-selection">
                            <SelectDropdown
                                id={'source_checkpoint_path_dropdown'}
                                dataTestId={'source_checkpoint_path_dropdown'}
                                inputLabel={"Source Checkpoint Path"}
                                onChange={(option) => updateSourceCheckpointPath(option.value)}
                                selectValue={sourceCheckpointPath}
                                options={sourceCheckpointPathOptions}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className={'extract-cleanse-sales-to-puc-column'}>
                        <div className={'extract-cleanse-sales-to-puc-selection-row'}>
                            <OutletsDropdown onChange={(option) => updateOutletDropdown(option)}
                                             value={outletSelection?.value}/>
                        </div>
                    </div>
                    <div className={'extract-cleanse-sales-to-puc-column'}>
                        <div className={'extract-cleanse-sales-to-puc-selection-row'}>
                            <PeriodsDropdown
                                id={"market_period"}
                                className={'data-row-dropdown'}
                                updatePeriod={updatePeriod}
                                periodLabel={'Market Period'}
                                selectedPeriod={period}
                                graphqlQuery={'{ marketPeriodList }'}/>
                        </div>
                    </div>
                    <div className={'extract-cleanse-sales-to-puc-column'}>
                        <div className={'extract-cleanse-sales-to-puc-selection-row'}>
                            <SelectDropdown
                                id={'projections-version_dropdown'}
                                inputLabel={'Projections Version'}
                                onChange={(option) => updateProjectionsVersionDropdown(option.value)}
                                selectValue={projectionsVersionSelection}
                                selectLabel={getValueFromOptions(projectionsVersionSelection, projectionsVersionOptions)?.label}
                                options={projectionsVersionOptions}
                                placeholder={'Select Projections Version...'}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={'extract-cleanse-sales-to-puc-column'}>
                <div className={'extract-cleanse-sales-to-puc-trigger-dag-row'}>
                    <ButtonLoader
                        buttonTitle={"Trigger Dag"}
                        buttonHasModal
                        buttonClassName={"button primary "}
                        modalText={`Are you sure you want to get trigger ${DAG_ID_TO_TRIGGER}?  \n ${JSON.stringify({
                            exclude_already_processed_items: excludeAlreadyProcessedItems,
                            source_checkpoint_path: sourceCheckpointPath,
                            outlet: outletSelection.outletName,
                            outlet_id: outletSelection.value,
                            market_period: period,
                            projections_version: projectionsVersionSelection
                        }, null, 2)}`}
                        axiosFunction={() => triggerDag()}
                        toastTextFailure={`${DAG_ID_TO_TRIGGER} DAG trigger failed with error`}
                        toastTextSuccess={`${DAG_ID_TO_TRIGGER} DAG triggered successfully with response`}
                    />
                </div>
            </div>
        </LoadingWrapper>
        <br/>
        <AirflowDagLogs
            processName={DAG_ID_TO_TRIGGER}
            includeDagName={false}
            customColumns={[
                {
                    header: 'Output File',
                    accessorKey: 'runid',
                    cell: ({getValue}) => {
                        const gsLinkPrefix = `gs://spins-edp-${process.env.REACT_APP_ENV}-data-test/p_dataset=extract_cleanse_sales_to_puc/`
                        const sanitizedRunId = `${getValue().replace(/([-.:+])/g, "_").toLowerCase()}_extract`;
                        return <a href={convertGsutilPathToBrowserGcsUrl(`${gsLinkPrefix}${sanitizedRunId}`)}
                                  target="_blank" rel="noopener noreferrer">{sanitizedRunId}</a>;
                    },
                },
                {header: 'Exclude Already Processed Items', accessorKey: 'conf.exclude_already_processed_items'},
                {header: 'Source Checkpoint Path', accessorKey: 'conf.source_checkpoint_path'}
            ]}
        />
    </Page>);
};

export default ExtractCleanseSalesToPuc;